import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import DistributorEnumsViewModel from "viewModels/timeCharges/distributorEnums/distributorEnumsViewModel";
import Tabs from "views/common/tabs";

const DistributorEnumsView: ViewComponent<DistributorEnumsViewModel> = observer(({ vm }) => {
  return (
    <>
      <h3 className="mb-4">{vm.name}</h3>
      <Tabs vm={vm} />
    </>
  );
});

registerView(DistributorEnumsView, DistributorEnumsViewModel);
